import React from 'react';

const PayNow = () => {
    return (
        <div>
            <h2>Payment System Will be added soon!!! Thank You</h2>
        </div>
    );
};

export default PayNow;